export const isPromise = (thing: any): thing is Promise<any> => {
  return thing instanceof Promise
}
